import React from 'react';

const Video = (props) => {
  /*if(props.video !== null)と同じ表現。データがないときはその後のコードは何も読み込まれない。null以外の時だけ、それ以降のコードが実行される。*/
  if(!props.video){
    return(
      <div className="video col-md-8">
        <p style={{textAlign: "center"}}>Now Loading...。</p>
      </div>
    );
  }
  /*データが取得できていないときは、ここから下のコードは実行されない*/
  const videoURL = "https://www.youtube.com/embed/" + props.video.id.videoId;

  return (

    <div className="video col-md-8" >
      <div className="embed-responsive embed-responsive-16by9" >
        {/*iframeはtitleというattributeを追加するのが正しい設置方法。*/}
        <iframe className="embed-responsive-item" src={videoURL} title="selectedVideo" />
      </div>
      <div className="info">
        {/*snippetからtitle(題名)とdescription(概要)を取得する*/}
        <h4 className="mt-2 font-weight-bold">{props.video.snippet.title}</h4>
        <p>{props.video.snippet.description}</p>
      </div>
    </div>
  );
}

export default Video;



// WEBPACK FOOTER //
// ./src/components/Video/Video.js